import {Injectable} from '@angular/core';
import {ServiceHttpService} from './services.http.service';
import {ServiceDocumentPendingApprovalModel} from '../models/service-document-pending-approval-model';
import {
    ModalServicesDataProcessingAgreementComponent
} from '../components/modal-services-data-processing-agreement/modal-services-data-processing-agreement.component';
import {
    ModalAgreementNotConfirmedInfoComponent
} from '../components/modal-agreement-not-confirmed-info/modal-agreement-not-confirmed-info.component';
import {ModalDynamicV3Service} from '../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {UserContextService} from '../../../core/services/user-context.service';
import {ModalResultModel} from '../../../shared-modal-dynamic/models/modal-result-model';
import {
    ModalServicesDataProcessingAgreementNewComponent
} from '../components/modal-services-data-processing-agreement-new/modal-services-data-processing-agreement-new.component';

@Injectable()
export class ServicesApprovalService {

    constructor(
        private serviceHttpService: ServiceHttpService,
        private modalDynamicV3Service: ModalDynamicV3Service,

    ) {
    }


    // /**
    //  * checks if there are any service documents pending approval and if yes, opens a modal for each document
    //  * and asks the user to approve it. If the user approves all documents, returns true, otherwise false.
    //  */
    // async areServicesApprovedOld(): Promise<boolean> {
    //     let documents: ServiceDocumentPendingApprovalModel[];
    //     try {
    //         documents = await this.serviceHttpService.getPendingDocumentsToApprove();
    //     } catch (e) {
    //         documents = [];
    //         console.error('Error fetching agreement documents', e);
    //     }
    //
    //     if (!documents?.length) {
    //         return true;
    //     }
    //
    //     return this.approveNotApprovedDocuments(documents);
    // }


    // is used in old and new areServicesApproved methods
    private async approveNotApprovedDocuments(documents: ServiceDocumentPendingApprovalModel[]): Promise<boolean> {
        let notApprovedDocuments = [...documents];

        for (const document of documents) {
            console.log('Document:', document);

            const modalResult = await new Promise<{ action: string }>(resolve => {
                this.modalDynamicV3Service.open(ModalServicesDataProcessingAgreementNewComponent, {model: document}).subscribe(
                    (result: ModalResultModel<null>) => {
                        resolve(result);
                    });
            });

            if (modalResult.action === ModalServicesDataProcessingAgreementComponent.ActionEnum.CONFIRM) {
                console.log('result', modalResult);
                notApprovedDocuments = notApprovedDocuments.filter(d => d.id !== document.id);
            } else {
                return false;
            }
        }

        return !notApprovedDocuments.length;
    }

    /**
     * service loads the pending documents, if there are any, then it checks if the user is representative or primary user
     * and if yes, it opens a modal for each document and asks the user to approve it. If the user approves all documents, returns true, otherwise false.
     * If the user is neither representative nor primary user, then it returns false.
     */
    async areServicesApproved(): Promise<boolean> {
        let documents: ServiceDocumentPendingApprovalModel[];
        try {
            documents = await this.serviceHttpService.getPendingDocumentsToApprove();
        } catch (e) {
            console.error('Error fetching agreement documents', e);
            return false;
        }

        if (!documents?.length) {
            return true; // No documents to approve
        }

        return this.approveNotApprovedDocuments(documents);
    }



    public showModalAgreementNotConfirmedInfo() {
        this.modalDynamicV3Service.open(ModalAgreementNotConfirmedInfoComponent);
    }

    // areThereDocumentsForApproval(): boolean {
    //     const userDetails = this.userContextService.getUserDetails() || {} as UserDetailsModel;
    //     return userDetails.someServiceDocRequireApproval;
    // }

    // async showWarningForPrimaryOrRepresentativeIfNeeded() {
    //     if (this.isRepresentativeOrPrimaryUser() && this.areThereDocumentsForApproval()) {
    //         let areServicesApproved = await this.areServicesApproved();  // loads documents and shows modals for approval
    //         if (!areServicesApproved && !this.userContextService.hasPermission(SecFEPermissionPartnerAppEnum.PAU_SERVICE)) {
    //
    //             let model: InfoModalModel = {
    //                 title: 'Achtung - fehlende Zustimmung',
    //                 htmlMessage: 'Mindestens ein Dokument wurde nicht akzeptiert. Das kann dazu führen, dass bestimmte Funktionen nicht verfügbar sind. ' +
    //                     'Alle offenen Dokumente werden Ihnen nach der nächsten Anmeldung wieder zur Zustimmung angezeigt.',
    //                 confirmButtonLabel: 'Verstanden'
    //             };
    //             this.modalDynamicV3Service.open(InfoModalComponent, {model});
    //         }
    //     }
    // }
}
